import { MyID } from "@greyhole/myid-connect/myid_connect";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback, useLayoutEffect } from "react";
import { dragonTransport, useClient } from "transport";
import { TOKEN_KEY } from "utils/constant";
import { useSignUpAndSignIn } from "./useAutoSignUpAndSignIn";

export const useAuth = () => {
  const client = useQueryClient();
  const myIdClient = useClient(MyID);
  const { mutateAsync } = useMutation(
    myIdClient.me.createUseMutationOptions({
      transport: dragonTransport("bison"),
    })
  );

  const getMe = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return;
    try {
      const res = await mutateAsync({});
      client.setQueryData(myIdClient.me.getQueryKey(), res);
      return res;
    } catch (error) {
      localStorage.removeItem(TOKEN_KEY);
      console.log("err: Me", `${error}`);
      return;
    }
  }, []);

  return { getMe };
};
